// extracted by mini-css-extract-plugin
export default {"notification-card":"notification-card_notification-card__HA6gl","noNotifications":"notification-card_noNotifications__XkdkL"};